var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFunctions = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.662 8.365a.206.206 0 0 0-.15-.342h-1.834a.2.2 0 0 0-.154.071l-3.106 3.712a.2.2 0 0 1-.217.063.2.2 0 0 1-.122-.112l-1.605-3.612a.2.2 0 0 0-.184-.12H9.029l.022-.12.203-1.081c.265-1.416.96-2.08 2.168-2.08.47 0 .897.043 1.233.12l.357-1.708c-.572-.12-.89-.156-1.388-.156-2.61 0-3.953 1.132-4.445 3.765L6.94 8.028H4.474a.2.2 0 0 0-.197.163l-.273 1.324a.206.206 0 0 0 .197.248h2.384l-2.25 10.99a.206.206 0 0 0 .197.247h1.674a.2.2 0 0 0 .197-.164L8.67 9.766h3.432l1.723 3.555a.21.21 0 0 1-.03.225l-4.564 5.19a.207.207 0 0 0 .017.288c.037.033.085.05.134.051h1.838c.06 0 .116-.025.154-.071l3.126-3.75a.203.203 0 0 1 .339.046l1.663 3.647c.033.072.103.12.184.12h1.633a.204.204 0 0 0 .182-.293l-2.406-5.084a.2.2 0 0 1 .033-.225z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFunctions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/functions.e8f6c821.svg";